import React from 'react';
import { cn } from '../../utils';

const StatsCard = ({ 
  title, 
  value, 
  icon: Icon, 
  variant = 'default',
  className = '',
  ...props 
}) => {
  const variants = {
    default: 'bg-gray-50 border border-gray-200 hover:bg-gray-100 hover:border-gray-300 hover:shadow-gray-200/50',
    success: 'bg-green-50 border border-green-200 hover:bg-green-100 hover:border-green-300 hover:shadow-green-200/50',
    warning: 'bg-orange-50 border border-orange-200 hover:bg-orange-100 hover:border-orange-300 hover:shadow-orange-200/50',
    danger: 'bg-red-50 border border-red-200 hover:bg-red-100 hover:border-red-300 hover:shadow-red-200/50',
    info: 'bg-blue-50 border border-blue-200 hover:bg-blue-100 hover:border-blue-300 hover:shadow-blue-200/50'
  };

  const iconVariants = {
    default: 'text-gray-600 bg-gray-100',
    success: 'text-green-600 bg-green-100',
    warning: 'text-orange-600 bg-orange-100',
    danger: 'text-red-600 bg-red-100',
    info: 'text-blue-600 bg-blue-100'
  };

  return (
    <div 
      className={cn(
        'group rounded-lg p-6 shadow-sm transition-all duration-300 ease-in-out hover:shadow-xl hover:scale-105 cursor-pointer',
        variants[variant],
        className
      )}
      {...props}
    >
      <div className="flex items-center">
        {Icon && (
          <div className={cn(
            'flex-shrink-0 mr-4 p-3 rounded-full transition-all duration-300 ease-in-out group-hover:scale-110',
            iconVariants[variant]
          )}>
            <Icon className="h-6 w-6 transition-transform duration-300 ease-in-out group-hover:rotate-12" />
          </div>
        )}
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1 transition-colors duration-300">
            {title}
          </p>
          <p className={`text-2xl font-bold text-gray-900 transition-all duration-300 group-hover:text-gray-800 group-hover:scale-105 ${className || ''}`}>
            {value}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
